export default function Tooltip() {
    return {
        MuiTooltip: {
            styleOverrides: {
                popper: {
                    ".MuiTooltip-tooltip": {
                        // @TODO Sandeep/Sanjeev: Make this more specific
                        backgroundColor: "#001E3F !important",
                    },
                    ".MuiTooltip-arrow::before": {
                        backgroundColor: "#001E3F",
                    },
                },
            },
        },
    };
}
